var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirdrop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.996 7.97656C19.4999 3.16016 14.4062 0 10 0C5.5938 0 0.500099 3.16016 0.00401025 7.97656C-0.0389581 8.39453 0.269632 8.75 0.629004 8.75H1.89852L6.25004 13.4922V18.75C6.25004 19.4414 6.80863 20 7.50003 20H12.5C13.1914 20 13.75 19.4414 13.75 18.75V13.4922L18.0976 8.75H19.3671C19.7304 8.75 20.039 8.39453 19.996 7.97656V7.97656ZM10 1.25C12.0234 1.25 14.375 3.75 14.375 7.5H5.62505C5.62505 3.75 7.97658 1.25 10 1.25ZM1.33993 7.5C1.86337 4.95703 3.94538 3 6.38285 1.99609C5.20708 3.27344 4.37506 5.16016 4.37506 7.46875V7.5H1.33993ZM7.03519 12.5L3.59382 8.75H9.37501V12.5H7.03519V12.5ZM12.5 18.4375C12.5 18.6094 12.3594 18.75 12.1875 18.75H7.81252C7.64065 18.75 7.50003 18.6094 7.50003 18.4375V14.0625C7.50003 13.8906 7.64065 13.75 7.81252 13.75H12.1875C12.3594 13.75 12.5 13.8906 12.5 14.0625V18.4375ZM12.9648 12.5H10.625V8.75H16.4023L12.9648 12.5ZM15.6249 7.5V7.46875C15.6249 5.16016 14.7929 3.27734 13.6171 1.99609C16.0507 3 18.1366 4.95703 18.6601 7.5H15.6249Z",
    fill: "#9C9EA5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirdrop);
export default __webpack_public_path__ + "static/media/airdrop.a07df899.svg";
export { ForwardRef as ReactComponent };